<div *ngIf="!user">
  <span *ngIf="labelText" nbTooltip="{{ tooltipText }}">{{
    labelText | timeago
  }}</span>
  <span *ngIf="!labelText">{{ emptyStateLabelText || '-' }}</span>
</div>

<div class="d-flex">
  <div *ngIf="user">
    <p class="mb-0 d-flex user-name-container">
      <nb-icon icon="{{ icon }}" status="basic" class="mr-1"></nb-icon>
      {{ user }}
      <ng-container *ngIf="showBadge">
        <nb-badge
          [text]="badgeConfig?.text"
          [style.color]="badgeConfig?.color"
          [style.background]="badgeConfig?.background"
          [style.height]="'fit-content'"
          position="null"
          class="ml-2 position-relative"
        ></nb-badge>
      </ng-container>
    </p>
    <p
      *ngIf="labelText"
      nbTooltip="{{ tooltipText }}"
      class="title-secondary mb-0"
    >
      {{ labelText | timeago }}
    </p>
  </div>
</div>
